import StyleSheet from 'react-native-extended-stylesheet';

export const style = StyleSheet.create({
  container: {
    width: '100%',
    display: 'flex',
    flexDirection: 'row',
    backgroundColor: '$colorBgBase',
    height: 48, // avoid using token because of tiny theme
    paddingHorizontal: '$space2',
  },
  title: {
    left: '$space12',
    right: '$space12',
    alignSelf: 'center',
  },
  backButton: {
    color: '$colorIcon',
    justifyContent: 'center',
    alignSelf: 'center',
    padding: '$space2',
  },
});
